module.exports = __webpack_public_path__ + "static/FK-3def84e1f236c41abe1930e548bfaecd.jpg";